import React from "react";

const EntryMoreModal = ({
  onChange,
  handleClick,
  infoModal,
  CleanInputs,
  isDisabled,
}) => {
  const { TrainerName, OwnerName, EntryName, Breeders, Pedigrees } = infoModal;

  return (
    <>
      <div
        className="modal fade"
        id="entryMoreModal"
        role="dialog"
        aria-hidden="false"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header headerModals">
              <h5 className="modal-title" id="entryMoreLabel">
                {EntryName}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => CleanInputs()}
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <form autoComplete="off">
                <label className="lead">Trainer Name</label>
                <input
                  className="form-control mb-3"
                  id="TrainerName"
                  name="TrainerName"
                  type="text"
                  data-key={infoModal.inputSelect}
                  onChange={onChange}
                  value={TrainerName}
                  maxLength={50}
                />
                <label className="lead">Owner Name</label>
                <input
                  className="form-control mb-3"
                  id="OwnerName"
                  name="OwnerName"
                  type="text"
                  maxLength={50}
                  data-key={infoModal.inputSelect}
                  onChange={onChange}
                  value={OwnerName}
                />
                <label className="lead">Breeders</label>
                <input
                  className="form-control mb-3"
                  id="Breeders"
                  name="Breeders"
                  type="text"
                  data-key={infoModal.inputSelect}
                  onChange={onChange}
                  value={Breeders}
                  maxLength={50}
                />
                <label className="lead">Pedigrees</label>
                <input
                  className="form-control mb-3"
                  id="Pedigrees"
                  name="Pedigrees"
                  type="text"
                  data-key={infoModal.inputSelect}
                  onChange={onChange}
                  value={Pedigrees}
                  maxLength={50}
                />
              </form>
            </div>

            <div className="modal-footer">
              {!isDisabled && (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => handleClick([infoModal], true)}
                >
                  Save
                </button>
              )}
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => CleanInputs()}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EntryMoreModal;
